import { ReactNode, useCallback, useState } from 'react'

interface PortfolioExpandableRowRenderProps {
  isExpanded: boolean
  hasExpandableContent: boolean
  toggleExpanded: () => void
}

interface PortfolioExpandableRowProps {
  hasExpandableContent: boolean
  renderMain: (props: PortfolioExpandableRowRenderProps) => ReactNode
  renderExpanded?: (props: PortfolioExpandableRowRenderProps) => ReactNode
  containerClassName?: string
}

const BASE_CONTAINER_CLASSNAME =
  'mb-4 last:mb-0 sm:mb-0 bg-[var(--color-portfolio-filters-bg)] sm:bg-transparent rounded-sm sm:rounded-none border border-[var(--color-kodiak-slider)] sm:border-0 shadow-sm sm:shadow-none overflow-hidden'

export function PortfolioExpandableRow({
  hasExpandableContent,
  renderMain,
  renderExpanded,
  containerClassName = '',
}: PortfolioExpandableRowProps) {
  const [isExpanded, setIsExpanded] = useState(false)

  const toggleExpanded = useCallback(() => {
    if (!hasExpandableContent) return
    setIsExpanded((previous) => !previous)
  }, [hasExpandableContent])

  return (
    <div className={`${BASE_CONTAINER_CLASSNAME} ${containerClassName}`}>
      {renderMain({ isExpanded, hasExpandableContent, toggleExpanded })}
      {isExpanded && hasExpandableContent && renderExpanded?.({ isExpanded, hasExpandableContent, toggleExpanded })}
    </div>
  )
}
